module.exports = __webpack_public_path__ + "img/answer-c4-5.f3a5ed45.png";